export class ScannerCallbacksBuilder {
  private callbacks: Scandit.Callbacks;

  constructor() {
    this.callbacks = new Scandit.Callbacks();
  }

  public setDidScan(didScanCallback: (scanSession: Scandit.ScanSession) => any): ScannerCallbacksBuilder {
    this.callbacks.didScan = didScanCallback;
    return this;
  }

  public setDidCancel(didCancelCallback: (reason: any) => any): ScannerCallbacksBuilder {
    this.callbacks.didCancel = didCancelCallback;
    return this;
  }

  public setDidChangeState(didChangeStateCallback: (newState: Scandit.BarcodePicker.State) => any): ScannerCallbacksBuilder {
    this.callbacks.didChangeState = didChangeStateCallback;
    return this;
  }

  public setDidManualSearch(didManualSearchCallback: (text: String) => any): ScannerCallbacksBuilder {
    this.callbacks.didManualSearch = didManualSearchCallback;
    return this;
  }

  public setDidRecognizeText(didRecognizeTextCallback: (recognizedText: Scandit.RecognizedText) => any): ScannerCallbacksBuilder {
    this.callbacks.didRecognizeText = didRecognizeTextCallback;
    return this;
  }

  public setDidFailToValidateLicense(didFailToValidateLicenseCallback: (error: Scandit.LicenseError) => any): ScannerCallbacksBuilder {
    this.callbacks.didFailToValidateLicense = didFailToValidateLicenseCallback;
    return this;
  }

  public setDidProcessFrame(didProcessFrameCallback: (base64Frame: Scandit.Frame) => any): ScannerCallbacksBuilder {
    this.callbacks.didProcessFrame = didProcessFrameCallback;
    return this;
  }

  public setDidChangeProperty(didChangePropertyCallback: (propertyName: string, newValue: any) => any): ScannerCallbacksBuilder {
    this.callbacks.didChangeProperty = didChangePropertyCallback;
    return this;
  }

  public setDidRecognizeNewCodes(
    didChangePropertyCallback: (matrixScanSession: Scandit.MatrixScanSession) => any
  ): ScannerCallbacksBuilder {
    this.callbacks.didRecognizeNewCodes = didChangePropertyCallback;
    return this;
  }

  public build(): Scandit.Callbacks {
    return this.callbacks;
  }
}
